import React, { Fragment, Component } from 'react';
import { Route, Switch } from 'react-router-dom';

import * as routes from '../constants/UiRoutes';
import * as constants from '../constants/AppConstants';
import { store } from '../index';
import { registerModal } from '../actions/modalActions';

import ChatPanel from '../components/ChatPanel/ChatPanelContainer';
import LandingScreen from '../components/LandingScreen/LandingScreenContainer';
import CreatePanel from '../components/CreatePanel/CreatePanelContainer';
import ChatDetailsPanel from '../components/ChatDetailsPanel/ChatDetailsPanelContainer';
import AttachmentView from '../components/AttachmentView/AttachmentViewContainer';
import AttachmentModal from '../components/AttachmentModal/AttachmentModalContainer';
import ChatInvite from '../components/ChatInvite/ChatInviteContainer';
import BrowsePanel from '../components/BrowsePanel/BrowsePanelContainer';
import UserSettingsPanel from '../components/UserSettingsPanel/UserSettingsPanelContainer';
import { Modal, Toast } from '@updox/ui-components';


export default class PageRoutes extends Component {
  previousLocation = this.props.location;

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    // set previousLocation if props.location is not modal
    if (
      prevProps.history.action !== constants.HISTORY_POP &&
      (!location.state || !location.state.modal)
    ) {
      this.previousLocation = this.props.location;
    }
  }

  configureModalRef = (modalElement) => {
    store.dispatch(registerModal(modalElement));
  };

  render() {
    const { location } = this.props;
    const { state } = location;
    const isModal = !!(
      state &&
      state.modal &&
      this.previousLocation !== location
    ); // not initial render

    return (
      <div className="content-area">
        <Switch location={isModal ? this.previousLocation : location}>
          <Route
            path={routes.CREATE_DM_URL}
            render={props => (
              <CreatePanel
                {...props}
                title={constants.CREATE_DM}
                qaId="CreateDirectMessage"
                type={constants.DIRECT_MESSAGE_TYPE}
              />
            )}
          />
          <Route
            path={routes.CREATE_CHANNEL_URL}
            render={props => (
              <CreatePanel
                {...props}
                title={constants.CREATE_CHANNEL}
                qaId="CreateChannel"
                type={constants.CHANNEL_TYPE}
              />
            )}
          />
          <Route exact path={routes.CHAT_DETAILS_URL}
            render={ props =>
              <Fragment>
                <ChatPanel {...props} />
                <ChatDetailsPanel {...props} />
              </Fragment>
            }
          />
          <Route exact path={routes.ATTACHMENT_URL} component={AttachmentView} />
          <Route exact path={routes.BROWSE} render={props => (
            <BrowsePanel initialFilterType={state ? state.initialFilterType : null} />
          )}/>
          <Route exact path={routes.CHAT_URL} component={ChatPanel} />
          <Route exact path="/" component={LandingScreen} />
          <Route exact path={routes.INVITE_URL}
            render={ props =>
              <Fragment>
                <ChatPanel {...props} />
                <ChatInvite {...props} />
              </Fragment>
            }
          />

          <Route
            exact
            path={routes.JOIN_CHANNEL_URL}
            render={props => <ChatPanel {...props} join />}
          />

          <Route path={routes.USER_SETTINGS}
            render={props => (
              <UserSettingsPanel
                {...props}
              />
            )}
          />
        </Switch>
        {isModal ? <Route path={routes.ATTACHMENT_URL} component={AttachmentModal} /> : null}
        <Toast.ToastContainer
          position={Toast.ToastPosition.TOP_RIGHT}
        />
        <Modal ref={this.configureModalRef} />
      </div>
    );
  }
}
